import { colorOperators } from '@jexop/color';
import { evaluate as coreEvaluator, registry, type Operator } from '@jexop/core';
import { dateTimeOperators } from '@jexop/date-time';
import { arrayConcatOperator, arrayIncludesOnlyOperator, arrayIncludesOperator, arrayJoinOperator, arrayLengthOperator, colorAlphaOperator, eventsOperator, featureActivityIsStartedOperator, formatDatePeriod, formatDistance, formatDurationOperator, formatNumber, formatSpeed, formatTimestamp, getTimezoneFromLocation, hasFeatureDataOperator, historyLink, ifFeatureDataOperator, ifFlag, ifRoleFunction, jsonOutput, lastEventOperator, lastEventTime, latestEventOccurredOperator, latestEventOperator, latitudeLongitude, layoutGrid, mergeOperator, objectKeyByIndex, objectValueByIndex, renderSimpleElement, responsiveBreakpoint, routeFunction, stringReplace, themeProperty, translate } from './operators';
import { cardinalDirection } from './operators/cardinal-direction';
import { boolMacros, stringMacros } from './operators/macros';
import { mapOperator } from './operators/map';
import { ui } from './operators/ui';

registry.addDefaults();
registry.add(dateTimeOperators);
registry.add(colorOperators);

registry.add({
  ...boolMacros,
  ...stringMacros,
  'array-concat': arrayConcatOperator,
  'array-join': arrayJoinOperator,
  'array-length': arrayLengthOperator,
  'array:includes': arrayIncludesOperator,
  'array:includesOnly': arrayIncludesOnlyOperator,
  'cardinal-direction': cardinalDirection,
  'color-alpha': colorAlphaOperator,
  'feature-event': lastEventOperator,
  'feature-all-events': eventsOperator,
  'feature-latest': latestEventOperator,
  'feature-latest-occurred': latestEventOccurredOperator,
  'feature-is-started': featureActivityIsStartedOperator,
  'format-distance': formatDistance,
  'format-duration': formatDurationOperator,
  'format-date-period': formatDatePeriod,
  'format-number': formatNumber,
  'format-speed': formatSpeed,
  'format-timestamp': formatTimestamp,
  'map': mapOperator,
  'merge': mergeOperator,
  'timezone-from-location': getTimezoneFromLocation,
  'has-feature-data': hasFeatureDataOperator,
  'if-flag': ifFlag,
  'if-feature-data': ifFeatureDataOperator,
  'if-role-function': ifRoleFunction,
  'json-output': jsonOutput as Operator,
  'last-event-time': lastEventTime,
  'latitude-longitude': latitudeLongitude,
  'layout-grid': layoutGrid,
  'object-value-by-index': objectValueByIndex,
  'object-key-by-index': objectKeyByIndex,
  'render-simple-element': renderSimpleElement,
  'responsive-breakpoint': responsiveBreakpoint,
  'route-function': routeFunction,
  'string-replace': stringReplace,
  'theme-property': themeProperty,
  'history:link': historyLink,
  translate,
  ui,
});

export const evaluate = (expression: unknown, context: object): unknown => coreEvaluator(expression, context);
